import { useFormContext } from 'react-hook-form';
import Papa from 'papaparse';

import { ButtonType } from '@xemplo/button';
import { DawnDownload } from '@xemplo/icons';
import {
  useGetBusinessUnitWorkersQuery,
  useGetTerminatedBusinessUnitWorkersQuery,
} from '@xemplo/lookups-query';
import { useGetPayrunByIdQuery } from '@xemplo/payrun-query';

import { FormFields } from '../../../../create-amendment.types';

import * as S from './bulk-upload.styles';

export const DownloadTemplateButton = () => {
  const { watch } = useFormContext<FormFields>();

  const { appliesTo, terminatedWorkers, businessUnit, payrun } = watch();

  const { data: payrunData } = useGetPayrunByIdQuery({
    id: payrun ?? null,
  });

  const { data: workerData, isLoading } = useGetBusinessUnitWorkersQuery({
    id: payrunData?.result?.businessUnitId ?? businessUnit ?? null,
    requestParams: { per_page: 0 },
  });

  const { data: terminatedWorkerData, isLoading: terminatedWorkersLoading } =
    useGetTerminatedBusinessUnitWorkersQuery({
      id: businessUnit ?? null,
      requestParams: { per_page: 0 },
    });

  const generateCsvData = () => {
    const appliesToWorkersArray = Array.isArray(appliesTo)
      ? appliesTo.map((item) => item.toString())
      : [];

    const terminatedWorkersArray = Array.isArray(terminatedWorkers)
      ? terminatedWorkers.map((item) => item.toString())
      : [];

    const selectedEmployees = workerData?.result.filter((employee) =>
      appliesToWorkersArray.includes(employee.id.toString()),
    );
    const selectedTerminatedEmployees = terminatedWorkerData?.result?.rows.filter(
      (employee) => terminatedWorkersArray.includes(employee.employeeId),
    );
    const data = selectedEmployees?.map((employee) => {
      return {
        ID: employee.id,
        Name: `${employee.firstName} ${employee.lastName}`,
        Rate: '',
        Unit: '',
      };
    });

    selectedTerminatedEmployees?.forEach((employee) => {
      data?.push({
        ID: +employee.employeeId,
        Name: `${employee.firstName} ${employee.lastName}`,
        Rate: '',
        Unit: '',
      });
    });
    return data ?? [];
  };

  const handleTemplateDownload = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const data = generateCsvData();
    //Generate csv file for download
    const fields = ['ID', 'Name', 'Rate', 'Unit'];
    const csv = Papa.unparse({
      data,
      fields,
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'template.csv');
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <S.DownloadTemplateButton
      onClick={handleTemplateDownload}
      ariaLabel="Download template"
      icon={<DawnDownload fontSize={16} />}
      type={ButtonType.Primary}
      disabled={isLoading || terminatedWorkersLoading}
    >
      Download Template
    </S.DownloadTemplateButton>
  );
};
